import { render } from "./supportFaq.vue?vue&type=template&id=717d4866&scoped=true&ts=true"
import script from "./supportFaq.vue?vue&type=script&lang=ts"
export * from "./supportFaq.vue?vue&type=script&lang=ts"

import "./supportFaq.vue?vue&type=style&index=0&id=717d4866&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717d4866"]])

export default __exports__